// Presentation copy shared by the two decorated skins; no sample rewards or payment data.
export default {
    en: {
        rankingIntro: 'Compete, play and win great rewards.',
        prizePool: 'Prize pool',
        member: 'Member',
        pendingRewards: 'Pending rewards',
        rewardHistory: 'Reward history',
        pendingIntro: 'Here you can find rewards you can still claim. Go to the activity to check its requirements.',
        historyIntro: 'View your reward history and claim status.',
        dailyAttendance: 'Daily check-in',
        timedEnvelope: 'Timed red envelope',
        luckyWheel: 'Lucky wheel',
        otherReward: 'Activity reward',
        gameBalance: 'Game balance',
        bonusBalance: 'Bonus balance',
        unclaimed: 'Unclaimed',
        claimed: 'Claimed',
        expired: 'Expired',
        goToActivity: 'Go to activity',
        noRewards: 'No rewards here yet',
        pullToRefresh: 'Pull down to refresh',
        releaseToRefresh: 'Release to refresh',
        refreshed: 'Refreshed successfully',
        pinIntro: 'Set a 6-digit password to authorize your withdrawals.',
        usdtDeposit: 'USDT deposit',
        confirmTransaction: 'Confirm transaction',
        stepOf: 'Step {step} of {total}',
        transferIntro: 'Transfer to the address below to complete your deposit.',
        hashIntro: 'Enter your deposit transaction hash (ID) to continue.',
        orderStates: {
            WaitPay: 'Awaiting payment',
            Paying: 'Processing',
            PaySuccess: 'Paid',
            Fail: 'Failed',
            Cancel: 'Cancelled'
        }
    },
    esMX: {
        rankingIntro: 'Compite, juega y gana grandes recompensas.',
        prizePool: 'Bolsa de premios',
        member: 'Miembro',
        pendingRewards: 'Recompensas pendientes',
        rewardHistory: 'Historial de recompensas',
        pendingIntro: 'Aquí encontrarás las recompensas que aún puedes reclamar. Ve a la actividad para consultar sus requisitos.',
        historyIntro: 'Consulta tu historial de recompensas y el estado de cada una.',
        dailyAttendance: 'Check-in diario',
        timedEnvelope: 'Sobre rojo programado',
        luckyWheel: 'Ruleta de la suerte',
        otherReward: 'Recompensa de actividad',
        gameBalance: 'Saldo de juego',
        bonusBalance: 'Saldo de bonos',
        unclaimed: 'Sin reclamar',
        claimed: 'Reclamada',
        expired: 'Vencida',
        goToActivity: 'Ir a la actividad',
        noRewards: 'Aún no hay recompensas',
        pullToRefresh: 'Desliza hacia abajo para actualizar',
        releaseToRefresh: 'Suelta para actualizar',
        refreshed: 'Actualizado correctamente',
        pinIntro: 'Establece una contraseña de 6 dígitos para autorizar tus retiros.',
        usdtDeposit: 'Depósito de USDT',
        confirmTransaction: 'Confirmar transacción',
        stepOf: 'Paso {step} de {total}',
        transferIntro: 'Realiza la transferencia a la siguiente dirección para completar tu depósito.',
        hashIntro: 'Ingresa el hash (ID de transacción) de tu depósito para continuar.',
        orderStates: {
            WaitPay: 'Pendiente de pago',
            Paying: 'En proceso',
            PaySuccess: 'Pagado',
            Fail: 'Fallido',
            Cancel: 'Cancelado'
        }
    },
    ptBR: {
        rankingIntro: 'Compita, jogue e ganhe grandes recompensas.',
        prizePool: 'Premiação',
        member: 'Membro',
        pendingRewards: 'Recompensas pendentes',
        rewardHistory: 'Histórico de recompensas',
        pendingIntro: 'Aqui estão as recompensas que você ainda pode resgatar. Acesse a atividade para consultar os requisitos.',
        historyIntro: 'Consulte seu histórico de recompensas e o status de cada uma.',
        dailyAttendance: 'Check-in diário',
        timedEnvelope: 'Envelope vermelho programado',
        luckyWheel: 'Roleta da sorte',
        otherReward: 'Recompensa de atividade',
        gameBalance: 'Saldo de jogo',
        bonusBalance: 'Saldo de bônus',
        unclaimed: 'Não resgatada',
        claimed: 'Resgatada',
        expired: 'Expirada',
        goToActivity: 'Ir para a atividade',
        noRewards: 'Ainda não há recompensas',
        pullToRefresh: 'Puxe para atualizar',
        releaseToRefresh: 'Solte para atualizar',
        refreshed: 'Atualizado com sucesso',
        pinIntro: 'Defina uma senha de 6 dígitos para autorizar seus saques.',
        usdtDeposit: 'Depósito de USDT',
        confirmTransaction: 'Confirmar transação',
        stepOf: 'Etapa {step} de {total}',
        transferIntro: 'Transfira para o endereço abaixo para concluir seu depósito.',
        hashIntro: 'Insira o hash (ID da transação) do depósito para continuar.',
        orderStates: {
            WaitPay: 'Aguardando pagamento',
            Paying: 'Em processamento',
            PaySuccess: 'Pago',
            Fail: 'Falhou',
            Cancel: 'Cancelado'
        }
    },
    ruRU: {
        rankingIntro: 'Соревнуйтесь, играйте и выигрывайте награды.',
        prizePool: 'Призовой фонд',
        member: 'Участник',
        pendingRewards: 'Доступные награды',
        rewardHistory: 'История наград',
        pendingIntro: 'Здесь находятся награды, которые ещё можно получить. Перейдите к акции, чтобы узнать условия.',
        historyIntro: 'История ваших наград и статус их получения.',
        dailyAttendance: 'Ежедневная отметка',
        timedEnvelope: 'Красный конверт по расписанию',
        luckyWheel: 'Колесо удачи',
        otherReward: 'Награда за акцию',
        gameBalance: 'Игровой баланс',
        bonusBalance: 'Бонусный баланс',
        unclaimed: 'Не получена',
        claimed: 'Получена',
        expired: 'Истекла',
        goToActivity: 'К акции',
        noRewards: 'Наград пока нет',
        pullToRefresh: 'Потяните для обновления',
        releaseToRefresh: 'Отпустите для обновления',
        refreshed: 'Обновлено',
        pinIntro: 'Установите пароль из 6 цифр для подтверждения вывода средств.',
        usdtDeposit: 'Пополнение USDT',
        confirmTransaction: 'Подтверждение транзакции',
        stepOf: 'Шаг {step} из {total}',
        transferIntro: 'Переведите средства на указанный адрес для завершения пополнения.',
        hashIntro: 'Введите хеш (ID транзакции) пополнения, чтобы продолжить.',
        orderStates: {
            WaitPay: 'Ожидает оплаты',
            Paying: 'Обрабатывается',
            PaySuccess: 'Оплачено',
            Fail: 'Ошибка',
            Cancel: 'Отменено'
        }
    }
}
